export const viewTypes = {
  DOCUMENT: 'document',
  PROJECT: 'project',
  ADMIN: 'admin',
};
